import { useFindUserContextPreferences } from '../../../../../services/modules/userContextPreferences/userContextPreferences.queries';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { getRecentBrandIds, orderBrandsForSelector } from '../storeConnections.utils';

export const useStoreRecentBrands = () => {
  const { state } = useApplicationContext();
  const { data: preferences, isLoading } = useFindUserContextPreferences();

  const brands = orderBrandsForSelector(state.brands, getRecentBrandIds(preferences));

  return {
    brands,
    totalCount: state.brands.length,
    isLoading: isLoading || state.isLoadingBrands,
  };
};
